import Point = createjs.Point;
import Rectangle = createjs.Rectangle;

export class FrameVO {
    private _frameName: string;
    private _posOnSheet: Rectangle;
    private _registrationPoint: Point;
    private offsetX: number;
    private offsetY: number;

    constructor(offsetX: number = 0, offsetY: number = 0) {
        this.offsetX = offsetX;
        this.offsetY = offsetY;
    }

    public loadFromParamObject(paramObject: any): void {
        let frameName: string = String(paramObject.filename);
        this._frameName = frameName.substr(0, frameName.length - 4);
        this._posOnSheet = new Rectangle(paramObject.frame.x, paramObject.frame.y, paramObject.frame.w, paramObject.frame.h);
        this._registrationPoint = new Point(this.offsetX - paramObject.spriteSourceSize.x, this.offsetY - paramObject.spriteSourceSize.y);
    }

    public get frameName(): string {
        return this._frameName;
    }

    public get posOnSheet(): Rectangle {
        return this._posOnSheet;
    }

    public get registrationPoint(): Point {
        return this._registrationPoint;
    }
}
